<template>
	<div class="HomeView bg-color" style="height: 100%">
		<homeHeader
			ref="homeHeader"
			:active_header_tab="active_type_tab"
			@handle_active_type_tab="handle_active_type_tab"
		/>
		<div v-show="active_type_tab == 0">
			<!-- <iframe
				id="appCenter"
				style="border: none; width: 100%; height: 99%"
				:src="
					iframeSrc
				"
			></iframe> -->
			<appManagement
				ref="appManagementRef"
				:active_type_tab="active_type_tab"
				v-if="user.userId!=null && user.userId"
				:userId="user.userId"
				:oid="user.organizeid"
				:org="user.org"
				:region="region"
			/>
		</div>
		<div class="cardView" v-if="[1].includes(active_type_tab)">
			<div class="cv_left" :style="!showMyFavorites?`width:0px;min-width:0`:``">
				<CollectPage :active_type_tab="active_type_tab" v-show="showMyFavorites"/>
        <span class="my_favoritesBtn" :class="{my_favoritesBtn_close:!showMyFavorites}" @click="showMyFavorites = !showMyFavorites">
          <img src="@/assets/img/appCenter/packUp_icon.svg">
        </span>
			</div>
			<div
				class="cv_right"
				v-loading="agentListLoading"
				:element-loading-text="lang.get_data_in"
			>
				<div class="cv_r_top" ref="cvRTopRef">
					<div class="flex_x_item">
						<div class="mr-10">
							<el-button
								size="small"
								class="customer-support-btn"
								v-if="user.organizeid == ORGANIZATION_CONSTANTS.COCOROBO_ORG_ID"
								@click="$router.push('/CustomerSupportAgentPage')"
							>
								{{ lang.customer_support || 'ai-bot 配置' }}
							</el-button>
						</div>
						<div class="mr-10">
							<el-select
								v-model="select_modelValue"
								:placeholder="lang.agent_sort"
								style="width: 100px"
							>
								<el-option
									v-for="item in select_modelValueOptions"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
						</div>

						<div class="mr-10">
							<el-select
								v-model="statusOptionsValue"
								:placeholder="lang.select_status"
								style="width: 100px"
							>
								<el-option
									v-for="(item, index) in statusOptions"
									:key="index"
									:label="item.label"
									:value="item.value"
								>
								</el-option>
							</el-select>
						</div>
						<!-- <el-popover
							placement="bottom"
							width="200"
							trigger="click"
							@hide="checkTagHide"
							@show="checkTagShow"
						>
							<div class="tag_popover_content flex_y">
								<el-checkbox
									class="tag_popover_content_item"
									:indeterminate="isIndeterminate"
									v-model="checkAll"
									@change="handleCheckAllChange"
									>{{ lang.selectAll }}</el-checkbox
								>
								<el-checkbox-group
									class="flex_y"
									v-model="tagOptionsValueList"
									@change="handleCheckedCitiesChange"
								>
									<el-checkbox
										class="tag_popover_content_item"
										v-for="(item, tag_index) in tagOptions"
										:label="item.name"
										:key="tag_index"
										>{{ item.name }}</el-checkbox
									>
								</el-checkbox-group>
							</div>
							<div slot="reference" class="tag_select">
								<span
									class="t_s_default"
									v-if="tagOptionsValueList.length <= 0"
									>{{ lang.agent_tag }}</span
								>
								<span v-else>{{ lang.checked }}</span>
								<i class="el-icon-arrow-down"></i>
							</div>
						</el-popover> -->
						<div class="mr-10">
							<el-input
								v-model="searchInput"
								style="width: 240px"
								:placeholder="lang.search"
								@keyup.enter.native="$refs.AgentListRef.changeSearchValue()"
							>
								<i
									slot="suffix"
									class="searchInputIcon el-icon-search"
									@click="$refs.AgentListRef.changeSearchValue()"
								></i
							></el-input>
						</div>
					</div>
				</div>
				<div class="cv_r_bottom">
					<AgentList
						ref="AgentListRef"
						:active_type_tab="active_type_tab"
						:search_input="searchInput"
						@get_tagOptions="get_tagOptions"
						:filter_tag="tagOptionsValue"
						:statusOptionsValue="statusOptionsValue"
						:tagOptionsValueList="tagOptionsValueList"
						:checkAll="checkAll"
						:selectType="select_modelValue"
					/>
				</div>
			</div>
		</div>
		<div v-show="active_type_tab == 2" style="width: 100%; height: 100%">
			<iframe
				id="knowledgeBase"
				v-if="knowledgeBaseUrl"
				style="border: none; width: 100%; height: 99%"
				:src="knowledgeBaseUrl"
				allow="camera *; microphone *;display-capture;midi;encrypted-media;fullscreen *;"
			></iframe>
		</div>
		<div class="appSelection" v-if="active_type_tab == 3">
			<appSelection ref="appSelectionRef" />
		</div>
		<div class="cocobookllm" v-show="active_type_tab == 5">
			<cocobookllm ref="cocobookllm" :show="active_type_tab == 5"/>
		</div>
		<div class="teachingMode" style="width: 100%;height: 100%;" v-if="active_type_tab == 4">
			<teachingMode ref="teachingModeRef"/>
		</div>
	</div>
</template>
<script>
import homeHeader from "./common/homeHeader.vue";
import CollectPage from "./index/CollectPage.vue";
import AgentList from "./index/AgentList.vue";
import appSelection from "./appSelection/appSelection.vue";
import appManagement from "./appManagement/appManagement.vue";
import cocobookllm from "./cocobookllm/index.vue";
import teachingMode from './teachingMode/teachingMode.vue'
import { getInitialTabValue } from '@/common/org.js';
import { ORGANIZATION_CONSTANTS, USER_TYPE_CONSTANTS } from '@/common/constants.js';
export default {
	name: "WorkSpace",
	components: {
		homeHeader,
		CollectPage,
		AgentList,
		appSelection,
		appManagement,
		cocobookllm,
		teachingMode
	},
	data() {
		return {
			ORGANIZATION_CONSTANTS,
			iframeSrc: "",
			active_type_tab: 0,
			select_modelValue: 0,
			statusOptionsValue: "",
			statusOptions: [
				// {
				// 	label: this.lang.all,
				// 	value: "",
				// },
				{
					label: this.lang.unreleased,
					value: "0",
				},
				{
					label: this.lang.released,
					value: "1",
				},
			],
			tagOptionsValue: "",
			tagOptions: [
				{
					// name: this.lang.all,
				},
			],
			region: "cn",
			searchInput: "",
			iframe_loading: true,
			agentListLoading: false,
			tagOptionsValueList: [],
			isIndeterminate: false,
			checkAll: false,
			oldCheck: null,
			select_modelValueOptions: [
				{ value: 0, label: this.lang.all },
				{ value: 1, label: this.lang.intelligent_agents },
				{ value: 2, label: this.lang.workflow },
				{ value: 3, label: this.lang.aiCode },
			],
			knowledgeBaseUrl: "",
      showMyFavorites:false,
		};
	},
	computed: {
		statusOptionsValueJoin() {
			// return this.statusOptionsValue.join(',')
			return "";
		},
		cvRTopRefEl() {
			let _result = null;
			if ([1, 2].includes(this.active_type_tab)) {
				_result = this.$refs.cvRTopRef;
			}

			return _result;
		},
	},
	watch: {
		active_type_tab(value) {
			if ([1, 2].includes(value)) {
				this.$nextTick(() => {
					const cvRTopRef = this.$refs.cvRTopRef;
					cvRTopRef.addEventListener("mouseenter", () => {
						cvRTopRef.addEventListener("wheel", (event) => {
							event.preventDefault(); // 阻止默认滚动行为
							this.$refs.AgentListRef.$refs.showItemBoxRef.scrollTop +=
								event.deltaY; // 根据滚轮的移动量调整滚动位置
						});
					});
					cvRTopRef.addEventListener("mouseleave", () => {
						cvRTopRef.removeEventListener("wheel", this.handleWheel); // 移除事件监听
					});
				});
			}
		}
	},
	activated() {
		if (this.$route.query.tabL) {
			let tab = this.$route.query.tabL ? parseInt(this.$route.query.tabL) : 0;
			tab = getInitialTabValue(tab, this.user);
			tab = this.getTabByUserType(tab, this.user);
			this.$refs.homeHeader.checkTab(this.$refs.homeHeader.header_tab_list2.find(e=>e.value == tab))
			this.$router.push({ 
				path: '/', 
				query: {} 
			});
		}
	},
	mounted() {
		setTimeout(()=>{
			let tab = this.$route.query.tab ? parseInt(this.$route.query.tab) : 0;
			tab = getInitialTabValue(tab, this.user);
			tab = this.getTabByUserType(tab, this.user);
			this.$refs.homeHeader.checkTab(this.$refs.homeHeader.header_tab_list2.find(e=>e.value == tab))
		}, 0)
		this.region = this.user.orgArea;
		this.bus.$on("handle_change_orgArea", (value) => {
			this.region = value;
		});
		if(window.location.href.includes(".com")){
			this.knowledgeBaseUrl = `https://storage.cocorobo.com/dist/#/knowledge?userid=${this.user.userId}&oid=${this.user.organizeid}&org=${this.user.org}&region=com`;
			this.region = 'com'
			this.user.orgArea = 'com'
		}else if(window.location.href.includes(".hk")){
			this.knowledgeBaseUrl = `https://storage.cocorobo.hk/dist/#/knowledge?userid=${this.user.userId}&oid=${this.user.organizeid}&org=${this.user.org}&region=hk`;
		}else{
			this.knowledgeBaseUrl = `https://storage.cocorobo.cn/dist/#/knowledge?userid=${this.user.userId}&oid=${this.user.organizeid}&org=${this.user.org}&region=${this.region}`;
		}
		console.log(this.lang.lang);
		console.log(this.knowledgeBaseUrl);
	},
	methods: {
		/**
		 * 根据用户类型调整 tab 值
		 * 如果用户类型为2(学生)，则返回 tab = 1
		 * @param {number} tab - 原始 tab 值
		 * @param {Object} user - 用户对象
		 * @returns {number} - 调整后的 tab 值
		 */
		getTabByUserType(tab = 0, user = {}) {
			if (user?.type === USER_TYPE_CONSTANTS.STUDENT_TYPE) {
				return ORGANIZATION_CONSTANTS.STUDENT_DEFAULT_TAB;
			}
			return tab;
		},
		onIframeLoad() {
			this.iframe_loading = false;
		},
		handle_active_type_tab(index) {
			this.searchInput = "";
			this.active_type_tab = index;
		},
		get_tagOptions(value) {
			this.tagOptions = [
				// {
				// 	name: this.lang.all,
				// },
			];
			this.tagOptions = this.tagOptions.concat(value);
		},
		handleCheckAllChange(value) {
			this.tagOptionsValueList = value
				? this.tagOptions.map((item) => item.name)
				: [];
			this.isIndeterminate = false;
		},
		handleCheckedCitiesChange(value) {
			let _len = value.length;
			if (_len == this.tagOptions.length) {
				this.checkAll = true;
			} else {
				this.checkAll = false;
			}
			this.isIndeterminate = _len > 0 && _len < this.tagOptions.length;
		},
		checkTagShow() {
			const oldCheck = this.tagOptionsValueList;
			this.oldCheck = oldCheck;
		},
		checkTagHide() {
			if (this.tagOptionsValueList != this.oldCheck) {
				this.$refs.AgentListRef.changeTagList();
			}
		},
	},
};
</script>
<style scoped>
@import url("@/assets/css/app_center.css");
.HomeView {
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
}

.cardView {
	width: 100%;
	height: 100%;
	display: flex;
}

.cv_left {
	width: clamp(200px, 12vw, 280px);
	min-width: 200px;
	height: 100%;
	background-color: #ffffff;
  position: relative;
}

.my_favoritesBtn{
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 16px;
	display: flex;
	align-items: center;
	color: #00000066;
	font-weight: 400;
  box-sizing: border-box;
  padding: 10px 10px 10px 10px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
}

.my_favoritesBtn_close{
  right: 0;
  transform: translateX(100%);
  background: #fff;
  border: solid 1px #E7E7E7;
  border-left: none;
  border-radius: 0 50px 50px 0;
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05);
}

.my_favoritesBtn_close>img{
  transform: rotate(180deg);
}


.my_favoritesBtn>img{
	width: 20px;
	height: 20px;
	margin-right: 5px;
}

.cv_right {
	flex: 1;
	height: 100%;
	background-image: url("@/assets/img/appCenter/background2.png");
	background-repeat: no-repeat;
	background-size: 100% 100%;
}

.cv_r_top {
	width: 100%;
	height: auto;
	margin: 10px 0;
	display: flex;
	box-sizing: border-box;
	padding-right: 20px;
	justify-content: flex-end;
}

.customer-support-btn {
	background-color: #f4f4f5;
	border-color: #e9e9eb;
	color: #909399;
	transition: all 0.3s;
}

.customer-support-btn:hover,
.customer-support-btn:focus {
	background-color: #e9e9eb;
	border-color: #d3d4d6;
	color: #606266;
}

.cv_r_bottom {
	width: 100%;
	height: auto;
}

.searchInputIcon {
	width: 20px;
	height: 20px;
	position: relative;
	top: 10px;
	right: 5px;
	font-size: 19px;
	cursor: pointer;
	/* cursor: pointer; */
}

.tag_select {
	width: 100px;
	height: 40px;
	box-sizing: border-box;
	background-color: #fff;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	margin-right: 10px;
	cursor: pointer;
	padding: 0 15px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: #606266;
	font-size: 14px;
}

.t_s_default {
	color: #c4c4cc;
}

.tag_popover_content_item {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}

.tag_popover_content_item >>> .el-checkbox__inner {
	width: 18px;
	height: 18px;
}

.tag_popover_content_item >>> .el-checkbox__inner::after {
	left: 6px !important;
	top: 3px !important;
}

.tag_popover_content_item >>> .el-checkbox__label {
	font-size: 16px;
	overflow: hidden;
	max-width: 160px;
	text-overflow: ellipsis;
	line-height: none;

	/* max-width: calc(100% - 20px);
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 1;
	overflow: hidden;
	text-overflow: ellipsis; */
}

.cocobookllm{
	width: 100%;
	height: calc(100% - 50px);
}
</style>
